import { Injectable } from '@angular/core';
import {
  NgbModal,
  NgbModalOptions,
  NgbModalRef,
} from '@ng-bootstrap/ng-bootstrap';
import { LoadingDialogComponent } from '../components/loading-dialog/loading-dialog.component';
import { LoginDialogComponent } from '../../pages/auth/login-dialog/login-dialog.component';
import { SignupDialogComponent } from '../../pages/auth/signup-dialog/signup-dialog.component';
import { ForgotPasswordDialogComponent } from '../../pages/auth/forgot-password-dialog/forgot-password-dialog.component';
import { OtpDialogComponent } from '../../pages/auth/otp-dialog/otp-dialog.component';
import { ResetPasswordComponent } from '../../pages/auth/reset-password/reset-password.component';
import { LoadingTripsDialogComponent } from '../components/loading-trips-dialog/loading-trips-dialog.component';
import { FundWalletDialogComponent } from '../../pages/dashboard/fund-wallet-dialog/fund-wallet-dialog.component';
import { FailedTransactionDialogComponent } from '../components/failed-transaction-dialog/failed-transaction-dialog.component';
import { TicketInstanceComponent } from 'src/app/pages/ticketing/ticket-instance/ticket-instance.component';
import { SearchResultsComponent } from 'src/app/core/components/search-results/search-results.component';
import { SearchBoxComponent } from 'src/app/core/components/search-box/search-box.component';
import { ConfirmDialogComponent } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';
import { NinVerificationPromptComponent } from 'src/app/shared/components/nin-verification-prompt/nin-verification-prompt.component';
import { NinVerificationModalComponent } from 'src/app/shared/components/nin-verification-modal/nin-verification-modal.component';

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  private modalRef: NgbModalRef | undefined;
  private loadingTripsodalRef: NgbModalRef | undefined;
  private forgotPasswordModalRef: NgbModalRef | undefined;
  private loginModalRef: NgbModalRef | undefined;
  private signupModalRef: NgbModalRef | undefined;
  private resetPasswordModalRef: NgbModalRef | undefined;
  private otpModalRef: NgbModalRef | undefined;
  private fundWalletDialog: NgbModalRef | undefined;
  private failedtransactionRef: NgbModalRef | undefined;
  private ticketRef: NgbModalRef | undefined;
  private searchResultRef: NgbModalRef | undefined;
  private confirmRef: NgbModalRef | undefined;
  private ninVerificationPromptRef: NgbModalRef | undefined;
  private ninVerificationModalRef: NgbModalRef | undefined;

  constructor(private modalService: NgbModal) {}

  openLoginDialog() {
    const dialogOptions: NgbModalOptions = {
      centered: true,
      size: 'md',
      // backdrop: 'static',
      // keyboard: false,
      modalDialogClass: 'login-dialog',
      backdropClass: 'login-dialog-backdrop',
    };
    const modalRef = (this.loginModalRef = this.modalService.open(
      LoginDialogComponent,
      dialogOptions
    ));

    return modalRef;
  }

  closeLoginModal() {
    this.loginModalRef?.close();
  }

  openSignUpDialog() {
    const dialogOptions: NgbModalOptions = {
      centered: true,
      size: 'md',
      // backdrop: 'static',
      // keyboard: false,
      modalDialogClass: 'login-dialog',
      backdropClass: 'login-dialog-backdrop',
    };
    const modalRef = (this.signupModalRef = this.modalService.open(
      SignupDialogComponent,
      dialogOptions
    ));

    return modalRef;
  }

  closeSignupModal() {
    this.signupModalRef?.close();
  }

  openOTPDialog(mode: string, email = '') {
    const dialogOptions: NgbModalOptions = {
      centered: true,
      size: 'md',
      backdrop: 'static',
      keyboard: false,
      modalDialogClass: 'login-dialog',
      backdropClass: 'login-dialog-backdrop',
    };
    const modalRef = (this.otpModalRef = this.modalService.open(
      OtpDialogComponent,
      dialogOptions
    ));
    modalRef.componentInstance.mode = mode;
    modalRef.componentInstance.email = email;
    return modalRef;
  }

  closeOTPModal() {
    this.otpModalRef?.close();
  }

  openFundWalletDialog() {
    const dialogOptions: NgbModalOptions = {
      centered: true,
      size: 'md',
    };
    this.fundWalletDialog = this.otpModalRef = this.modalService.open(
      FundWalletDialogComponent,
      dialogOptions
    );
    // this.fundWalletDialog.componentInstance.data;

    return this.fundWalletDialog;
  }

  closeFundWalletDialog() {
    this.fundWalletDialog?.close();
  }

  openResetPasswordDialog() {
    const dialogOptions: NgbModalOptions = {
      centered: true,
      size: 'md',
      modalDialogClass: 'login-dialog',
      backdropClass: 'login-dialog-backdrop',
    };
    const modalRef = (this.resetPasswordModalRef = this.modalService.open(
      ResetPasswordComponent,
      dialogOptions
    ));

    return modalRef;
  }

  closeResetPasswordModal() {
    this.resetPasswordModalRef?.close();
  }

  openForgotPasswordDialog() {
    const dialogOptions: NgbModalOptions = {
      centered: true,
      size: 'md',
      modalDialogClass: 'login-dialog',
      backdropClass: 'login-dialog-backdrop',
    };
    const modalRef = (this.forgotPasswordModalRef = this.modalService.open(
      ForgotPasswordDialogComponent,
      dialogOptions
    ));

    return modalRef;
  }

  closeForgotPasswordModal() {
    this.forgotPasswordModalRef?.close();
  }

  openLoadingDialog(
    title = 'Loading...',
    subtitle = 'Kindly give us a moment...'
  ) {
    const dialogOptions: NgbModalOptions = {
      centered: true,
      size: 'sm',
      backdrop: 'static',
      keyboard: false,
    };
    this.modalRef = this.modalService.open(
      LoadingDialogComponent,
      dialogOptions
    );
    // this.modalRef.
    this.modalRef.componentInstance.title = title;
    this.modalRef.componentInstance.subtitle = subtitle;
  }

  closeLoadingModal() {
    this.modalRef?.dismiss();
  }

  openLoadingTripsDialog(title = '', subtitle = '') {
    const dialogOptions: NgbModalOptions = {
      centered: true,
      size: 'sm',
      backdrop: 'static',
      keyboard: false,
    };
    this.loadingTripsodalRef = this.modalService.open(
      LoadingTripsDialogComponent,
      dialogOptions
    );
    this.loadingTripsodalRef.componentInstance.title = title;
    this.loadingTripsodalRef.componentInstance.subtitle = subtitle;
  }

  closeLoadingTripsModal() {
    this.loadingTripsodalRef?.close();
  }

  openFailedTransactionDialog(data: any) {
    const dialogOptions: NgbModalOptions = {
      centered: true,
      size: 'sm',
    };
    this.failedtransactionRef = this.modalService.open(
      FailedTransactionDialogComponent,
      dialogOptions
    );
    this.failedtransactionRef.componentInstance.data = data;

    return this.failedtransactionRef;
  }

  closeFailedTransactionDialog() {
    this.failedtransactionRef?.close();
  }

  openTicketDialog(ticket: any) {
    const dialogOptions: NgbModalOptions = {
      centered: true,
      // fullscreen: true,
      size: 'xl',
    };
    this.ticketRef = this.modalService.open(
      TicketInstanceComponent,
      dialogOptions
    );
    this.ticketRef.componentInstance.ticketToShow = ticket;
    this.ticketRef.componentInstance.showDownload = true;

    return this.ticketRef;
  }

  openSearchBox() {
    const dialogOptions: NgbModalOptions = {
      centered: true,
      size: 'xl',
    };
    this.searchResultRef = this.modalService.open(
      SearchBoxComponent,
      dialogOptions
    );
    this.searchResultRef.componentInstance.readonly = false;

    return this.searchResultRef;
  }

  confirm(messageTitle: string, messageBody: string) {
    const dialogOptions: NgbModalOptions = {
      centered: true,
    };
    this.confirmRef = this.modalService.open(
      ConfirmDialogComponent,
      dialogOptions
    );
    this.confirmRef.componentInstance.messageTitle = messageTitle;
    this.confirmRef.componentInstance.messageBody = messageBody;

    return this.confirmRef;
  }

  openNinVerificationPromptDialog() {
    const dialogOptions: NgbModalOptions = {
      centered: true,
      backdrop: 'static',
      keyboard: false,
      modalDialogClass: 'login-dialog',
      backdropClass: 'login-dialog-backdrop',
    };
    this.ninVerificationPromptRef = this.modalService.open(
      NinVerificationPromptComponent,
      dialogOptions,
    );

    return this.ninVerificationPromptRef;
  }

  openNinVerificationDialog() {
    const dialogOptions: NgbModalOptions = {
      centered: true,
      size: 'lg',
      backdrop: 'static',
      keyboard: false,
      modalDialogClass: 'login-dialog',
      backdropClass: 'login-dialog-backdrop',
    };
    this.ninVerificationModalRef = this.modalService.open(
      NinVerificationModalComponent,
      dialogOptions,
    );

    return this.ninVerificationModalRef;
  }

  closeNinVerificationPromptDialog() {
    this.ninVerificationPromptRef?.close();
  }

  closeNinVerificationDialog() {
    this.ninVerificationModalRef?.close();
  }
}
